import React from 'react';
import { Shield, Users, CreditCard, BarChart3 } from 'lucide-react';

interface AdminLandingCardProps {
  isKorean?: boolean;
}

const AdminLandingCard: React.FC<AdminLandingCardProps> = ({ isKorean = true }) => {
  return (
    <div className="bg-gradient-to-br from-red-50 to-orange-50 border-2 border-red-200 rounded-xl p-6 mb-8">
      <div className="flex items-center mb-4">
        <Shield className="w-8 h-8 text-red-600 mr-3" />
        <h2 className="text-2xl font-bold text-gray-900">
          {isKorean ? '관리자 도구' : 'Admin Tools'}
        </h2>
      </div>
      
      <p className="text-gray-700 mb-6">
        {isKorean 
          ? '관리자 권한이 확인되었습니다. 아래 관리 도구에 접근할 수 있습니다.'
          : 'Admin access confirmed. You can access the following management tools.'}
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <a
          href="/dashboard/mgmt"
          className="flex items-center p-4 bg-white rounded-lg border border-red-200 hover:border-red-400 hover:shadow-md transition-all duration-200 group"
        >
          <BarChart3 className="w-6 h-6 text-red-600 mr-3 group-hover:scale-110 transition-transform" />
          <div>
            <h3 className="font-semibold text-gray-900">
              {isKorean ? '통계 대시보드' : 'Analytics Dashboard'}
            </h3>
            <p className="text-sm text-gray-600">
              {isKorean ? '수익, 사용자, 구독 현황' : 'Revenue, Users, Subscriptions'}
            </p>
          </div>
        </a>
        
        <a
          href="/dashboard/mgmt#refunds"
          className="flex items-center p-4 bg-white rounded-lg border border-red-200 hover:border-red-400 hover:shadow-md transition-all duration-200 group"
        >
          <CreditCard className="w-6 h-6 text-red-600 mr-3 group-hover:scale-110 transition-transform" />
          <div>
            <h3 className="font-semibold text-gray-900">
              {isKorean ? '환불 관리' : 'Refund Management'}
            </h3>
            <p className="text-sm text-gray-600">
              {isKorean ? '환불 요청 검토 및 처리' : 'Review and process refunds'}
            </p>
          </div>
        </a>
        
        <a
          href="/dashboard/mgmt#users"
          className="flex items-center p-4 bg-white rounded-lg border border-gray-300 hover:border-gray-400 hover:shadow-md transition-all duration-200 group opacity-60 cursor-not-allowed"
        >
          <Users className="w-6 h-6 text-gray-400 mr-3" />
          <div>
            <h3 className="font-semibold text-gray-600">
              {isKorean ? '사용자 관리' : 'User Management'}
            </h3>
            <p className="text-sm text-gray-500">
              {isKorean ? '준비 중' : 'Coming Soon'}
            </p>
          </div>
        </a>
        
        <div className="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-200 opacity-60">
          <div className="w-6 h-6 bg-gray-200 rounded mr-3"></div>
          <div>
            <h3 className="font-semibold text-gray-600">
              {isKorean ? '추가 기능' : 'More Features'}
            </h3>
            <p className="text-sm text-gray-500">
              {isKorean ? '개발 중' : 'In Development'}
            </p>
          </div>
        </div>
      </div>
      
      <div className="mt-6 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p className="text-sm text-yellow-800">
          <strong>{isKorean ? '참고:' : 'Note:'}</strong> {isKorean 
            ? '관리자 기능은 데스크톱 브라우저에서 최적화되어 있습니다.'
            : 'Admin features are optimized for desktop browsers.'}
        </p>
      </div>
    </div>
  );
};

export default AdminLandingCard;